<template>
  <custom-dialog
    class="modify-project-leader-dialog"
    width="450px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item :label="$t('crm_contract_modify_project_leader_dialog.xiang_mu_fu_ze_ren')">
          <el-input v-model="form.val1"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_contract_modify_project_leader_dialog.xmfzrdh')">
          <el-input v-model="form.val2"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{
        $t('Common.com_confirm')
      }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/** 修改项目负责人 */

import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        val1: '',
        val2: ''
      },
      rules: {}
    };
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.closeDialog();
    }
  }
};
</script>

<style></style>
